import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "py-2"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "flex flex-col"
};
const _hoisted_4 = {
  class: "flex items-center"
};
const _hoisted_5 = ["onClick"];
import { Competition } from "@/modules/competitions/entity";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import Flag from "@/modules/vue/components/Flag.vue";
import NavBarMenu from "@/modules/vue/components/NavBarMenu.vue";
import NavBarMenuItem from "@/modules/vue/components/NavBarMenuItem.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  async setup(__props) {
    let __temp, __restore;
    const competitions = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      competitions.value = await Competition.createQueryBuilder('competition').innerJoinAndSelect('competition.country', 'country').innerJoinAndSelect('competition.divisions', 'division').getMany();
    })), __temp = await __temp, __restore(), __temp);
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(DefaultInGameLayout, null, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('competitions')), 1)]),
        submenu: _withCtx(() => [_createVNode(NavBarMenu, null, {
          default: _withCtx(() => [_createVNode(NavBarMenuItem, {
            to: {
              name: 'competitions.index'
            },
            label: _ctx.$t('competitions'),
            icon: _ctx.IconEnum.World
          }, null, 8, ["to", "label", "icon"])]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(competitions.value, competition => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: competition.id
          }, [_createElementVNode("div", {
            class: "py-2 cursor-pointer border-b last:border-b-0",
            onClick: $event => _ctx.$router.push({
              name: 'competitions.show',
              params: competition
            })
          }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [competition.country ? (_openBlock(), _createBlock(Flag, {
            key: 0,
            country: competition.country,
            class: "mr-2"
          }, null, 8, ["country"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(competition.name), 1)])])], 8, _hoisted_2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(competition.divisions, division => {
            return _openBlock(), _createElementBlock("div", {
              key: division.id,
              class: "pl-4 py-2 cursor-pointer border-b last:border-b-0",
              onClick: $event => _ctx.$router.push({
                name: 'competitions.show',
                params: competition,
                query: {
                  divisionId: division.id
                }
              })
            }, _toDisplayString(division.name), 9, _hoisted_5);
          }), 128))], 64);
        }), 128))])]),
        _: 1
      });
    };
  }
});